export default __webpack_public_path__ + "static/media/logo.f9f36c68.svg";